import type { UrlProvider } from '@mimir/common/io/urlProvider';
import type { BackendClient } from '@mimir/common/util/backendClient';
import { api_getItemFields } from './api';
import { Piggyback } from '@mimir/common/async/taskTracking';

export class ItemUrlProvider implements UrlProvider {
  private piggyback = new Piggyback<string>();

  constructor(
    private url: string,
    private fetchUrl: () => Promise<string>,
  ) { }

  getUrl(): string {
    return this.url;
  }

  async refreshUrl(): Promise<void> {
    this.url = await this.piggyback.runOrPiggyback(
      () => this.fetchUrl(),
    );
  }
}

export class HighresUrlProviderWithClient implements UrlProvider {
  private piggyback = new Piggyback<{ highRes?: string }>();

  constructor(
    private itemId: string,
    private url: string,
    private backendClient: BackendClient,
  ) { }

  getUrl(): string {
    return this.url;
  }

  async refreshUrl(): Promise<void> {
    const { highRes } = await this.piggyback.runOrPiggyback(
      () => api_getItemFields(this.backendClient, this.itemId, ['highRes']),
    );
    if (!highRes) {
      throw new Error(`Item ${this.itemId} does not have a high res URL`);
    }
    this.url = highRes;
  }
}
